import { Grid } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Container = styled(Grid)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: "100%",
  height: "100vh",
  backgroundColor: theme.palette.background.default,
}));

export const TextBlock = styled(Grid)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  gap: "5px",
}));
